import React, { useCallback } from 'react'
import { observer } from 'mobx-react'

import useInject from "~/hooks/useInject";
import DisplayInputContainer from './DisplayInputContainer'
import SimpleInput from '~/components/Form/SimpleInput'

const mapStore = store => ({
  user: store.auth.user
})

const Email = props => {
  const { user } = useInject(mapStore)
  const { isEditing } = props
  const userEmailError = user.validateDisplayMessage('email')

  const handleChange = useCallback(event => {
    const input = event.target.value
    user.changeKey('username', input)
    user.changeKey('email', input)
  }, [user])

  return (
    <DisplayInputContainer
      value={user.email}
      isEditing={isEditing}
      label="Email"
      error={userEmailError}
    >
      <SimpleInput 
        id="email"
        name="email"
        value={user.email}
        onChange={handleChange}
        error={userEmailError}
      />
    </DisplayInputContainer>
  )
}

export default observer(Email)